import(/* webpackMode: "eager" */ "/codebuild/output/src4071860333/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/testnet/page.tsx");
